export default "__VITE_ASSET__CAr7YilV__"